import { notification } from "antd";
import {
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
} from "../Types";
import { DcOffLineHost } from "../../config";

export const forgotPassword = (email) => {
  return async (dispatch) => {
    dispatch({ type: FORGOT_PASSWORD_REQUEST });

    try {
      const response = await fetch(`${DcOffLineHost}api/users/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(email),
      });
        const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message || "Erreur lors de l'enregistrement");
    }


      dispatch({ type: FORGOT_PASSWORD_SUCCESS, payload: data });

      notification.success({
        message: data?.message || "Enregistrement effectué avec success",
        duration: 5,
      });
      return data;
      
    } catch (error) {
      dispatch({ type: FORGOT_PASSWORD_FAILURE, payload: error?.message });

      notification.error({
        message: error?.message || "Erreur lors de l'enregistrement",
        duration: 5,
      });
    }
  };
};
